// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header.css */
.navbar {
    position: fixed;
    top: 0; /* Sempre enganxada a la part superior */
    left: 0;
    width: 100%; /* Ocupa tot l'ample de la pantalla */
    z-index: 100; /* Per assegurar que quedi per sobre del contingut */
    background-color: rgba(255, 255, 255, 0.9); /* Opcional: fons translúcid */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Opcional: petita ombra */
    transition: background-color 0.3s ease-in-out, box-shadow 0.3s ease-in-out; /* Per animacions suaus */
  }
  
  
  .navbar:hover {
    background-color: rgba(255, 255, 255, 0.9);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  .nav-link {
    font-weight: 500;
    color: #333 !important;
    transition: color 0.3s ease-in-out;
  }
  
  .nav-link:hover {
    color: #007bff !important;
    text-decoration: underline;
  }
  
  .btn-primary {
    background-color: #007bff;
    border: none;
    transition: background-color 0.3s ease-in-out, transform 0.2s ease-in-out;
  }
  
  .btn-primary:hover {
    background-color: #0056b3;
    transform: scale(1.05);
  }
  
  .dropdown-menu img {
    margin-right: 10px;
  }

  @keyframes wave {
    0% { transform: rotate(0deg); }
    25% { transform: rotate(10deg); }
    50% { transform: rotate(0deg); }
    75% { transform: rotate(-10deg); }
    100% { transform: rotate(0deg); }
  }
  
  .flag {
    width: 24px;
    height: auto;
    margin-right: 10px;
  }
  
  .flag-active {
    animation: wave 1s infinite;
  }
  
  .navbar-nav .btn {
    margin-left: auto; /* Assegura que el botó d'inici de sessió queda a la dreta */
  }

  /* Estil dels enllaços del menú */
.nav-link {
    color: #5f9ea0 !important; /* Blau cel */
    font-weight: 500; /* Lleugerament més gruixut */
    text-decoration: none !important; /* Elimina el subratllat */
    transition: color 0.3s ease; /* Suavitat en el canvi de color */
  }
  
  .nav-link:hover {
    color: #004080 !important; /* Blau més fosc al passar-hi el ratolí */
    text-decoration: none; /* Assegura que no es subratlli al passar-hi */
  }
  
  /* Opcional: icones al costat del text */
  .nav-link-icon {
    margin-right: 8px; /* Espai entre la icona i el text */
    vertical-align: middle; /* Centra la icona amb el text */
  }

  /* Estil del menú desplegable */
.dropdown-menu {
    background-color: rgba(255, 255, 255, 0.9); /* Fons translúcid */
    border: 1px solid rgba(0, 0, 0, 0.1); /* Borda suau */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Ombra subtil */
  }
  
  .dropdown-item {
    color: #5f9ea0 !important; /* Blau cel per defecte */
    font-weight: 500;
    text-decoration: none !important; /* Sense subratllat */
    padding: 8px 16px; /* Espaiat */
    transition: color 0.3s ease, background-color 0.3s ease; /* Canvi suau */
    align-items: center;
  }
  
  .dropdown-item:hover {
    color: #004080 !important; /* Blau més fosc al passar-hi el ratolí */
    background-color: rgba(240, 240, 240, 0.8); /* Lleuger gris clar */
    text-decoration: none; /* Sense subratllat */
  }
  
  /* Icónes del submenú */
  .dropdown-item .nav-link-icon {
    margin-right: 8px; /* Espai entre la icona i el text */
    vertical-align: middle; /* Centra la icona amb el text */
  }`, "",{"version":3,"sources":["webpack://./src/components/header.css"],"names":[],"mappings":"AAAA,eAAe;AACf;IACI,eAAe;IACf,MAAM,EAAE,wCAAwC;IAChD,OAAO;IACP,WAAW,EAAE,qCAAqC;IAClD,YAAY,EAAE,oDAAoD;IAClE,0CAA0C,EAAE,8BAA8B;IAC1E,wCAAwC,EAAE,2BAA2B;IACrE,0EAA0E,EAAE,yBAAyB;EACvG;;;EAGA;IACE,0CAA0C;IAC1C,0CAA0C;EAC5C;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;IACtB,kCAAkC;EACpC;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,yEAAyE;EAC3E;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,MAAM,wBAAwB,EAAE;IAChC,MAAM,uBAAuB,EAAE;IAC/B,MAAM,yBAAyB,EAAE;IACjC,OAAO,uBAAuB,EAAE;EAClC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB,EAAE,4DAA4D;EACjF;;EAEA,iCAAiC;AACnC;IACI,yBAAyB,EAAE,aAAa;IACxC,gBAAgB,EAAE,6BAA6B;IAC/C,gCAAgC,EAAE,0BAA0B;IAC5D,2BAA2B,EAAE,kCAAkC;EACjE;;EAEA;IACE,yBAAyB,EAAE,yCAAyC;IACpE,qBAAqB,EAAE,8CAA8C;EACvE;;EAEA,wCAAwC;EACxC;IACE,iBAAiB,EAAE,mCAAmC;IACtD,sBAAsB,EAAE,gCAAgC;EAC1D;;EAEA,+BAA+B;AACjC;IACI,0CAA0C,EAAE,oBAAoB;IAChE,oCAAoC,EAAE,eAAe;IACrD,wCAAwC,EAAE,iBAAiB;EAC7D;;EAEA;IACE,yBAAyB,EAAE,yBAAyB;IACpD,gBAAgB;IAChB,gCAAgC,EAAE,qBAAqB;IACvD,iBAAiB,EAAE,YAAY;IAC/B,uDAAuD,EAAE,eAAe;IACxE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB,EAAE,yCAAyC;IACpE,0CAA0C,EAAE,sBAAsB;IAClE,qBAAqB,EAAE,qBAAqB;EAC9C;;EAEA,uBAAuB;EACvB;IACE,iBAAiB,EAAE,mCAAmC;IACtD,sBAAsB,EAAE,gCAAgC;EAC1D","sourcesContent":["/* Header.css */\r\n.navbar {\r\n    position: fixed;\r\n    top: 0; /* Sempre enganxada a la part superior */\r\n    left: 0;\r\n    width: 100%; /* Ocupa tot l'ample de la pantalla */\r\n    z-index: 100; /* Per assegurar que quedi per sobre del contingut */\r\n    background-color: rgba(255, 255, 255, 0.9); /* Opcional: fons translúcid */\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Opcional: petita ombra */\r\n    transition: background-color 0.3s ease-in-out, box-shadow 0.3s ease-in-out; /* Per animacions suaus */\r\n  }\r\n  \r\n  \r\n  .navbar:hover {\r\n    background-color: rgba(255, 255, 255, 0.9);\r\n    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .nav-link {\r\n    font-weight: 500;\r\n    color: #333 !important;\r\n    transition: color 0.3s ease-in-out;\r\n  }\r\n  \r\n  .nav-link:hover {\r\n    color: #007bff !important;\r\n    text-decoration: underline;\r\n  }\r\n  \r\n  .btn-primary {\r\n    background-color: #007bff;\r\n    border: none;\r\n    transition: background-color 0.3s ease-in-out, transform 0.2s ease-in-out;\r\n  }\r\n  \r\n  .btn-primary:hover {\r\n    background-color: #0056b3;\r\n    transform: scale(1.05);\r\n  }\r\n  \r\n  .dropdown-menu img {\r\n    margin-right: 10px;\r\n  }\r\n\r\n  @keyframes wave {\r\n    0% { transform: rotate(0deg); }\r\n    25% { transform: rotate(10deg); }\r\n    50% { transform: rotate(0deg); }\r\n    75% { transform: rotate(-10deg); }\r\n    100% { transform: rotate(0deg); }\r\n  }\r\n  \r\n  .flag {\r\n    width: 24px;\r\n    height: auto;\r\n    margin-right: 10px;\r\n  }\r\n  \r\n  .flag-active {\r\n    animation: wave 1s infinite;\r\n  }\r\n  \r\n  .navbar-nav .btn {\r\n    margin-left: auto; /* Assegura que el botó d'inici de sessió queda a la dreta */\r\n  }\r\n\r\n  /* Estil dels enllaços del menú */\r\n.nav-link {\r\n    color: #5f9ea0 !important; /* Blau cel */\r\n    font-weight: 500; /* Lleugerament més gruixut */\r\n    text-decoration: none !important; /* Elimina el subratllat */\r\n    transition: color 0.3s ease; /* Suavitat en el canvi de color */\r\n  }\r\n  \r\n  .nav-link:hover {\r\n    color: #004080 !important; /* Blau més fosc al passar-hi el ratolí */\r\n    text-decoration: none; /* Assegura que no es subratlli al passar-hi */\r\n  }\r\n  \r\n  /* Opcional: icones al costat del text */\r\n  .nav-link-icon {\r\n    margin-right: 8px; /* Espai entre la icona i el text */\r\n    vertical-align: middle; /* Centra la icona amb el text */\r\n  }\r\n\r\n  /* Estil del menú desplegable */\r\n.dropdown-menu {\r\n    background-color: rgba(255, 255, 255, 0.9); /* Fons translúcid */\r\n    border: 1px solid rgba(0, 0, 0, 0.1); /* Borda suau */\r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Ombra subtil */\r\n  }\r\n  \r\n  .dropdown-item {\r\n    color: #5f9ea0 !important; /* Blau cel per defecte */\r\n    font-weight: 500;\r\n    text-decoration: none !important; /* Sense subratllat */\r\n    padding: 8px 16px; /* Espaiat */\r\n    transition: color 0.3s ease, background-color 0.3s ease; /* Canvi suau */\r\n    align-items: center;\r\n  }\r\n  \r\n  .dropdown-item:hover {\r\n    color: #004080 !important; /* Blau més fosc al passar-hi el ratolí */\r\n    background-color: rgba(240, 240, 240, 0.8); /* Lleuger gris clar */\r\n    text-decoration: none; /* Sense subratllat */\r\n  }\r\n  \r\n  /* Icónes del submenú */\r\n  .dropdown-item .nav-link-icon {\r\n    margin-right: 8px; /* Espai entre la icona i el text */\r\n    vertical-align: middle; /* Centra la icona amb el text */\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
